import React from 'react';

const Desktop = ({
  size = '48',
  color = '#56B0BB'
}: {
  size?: string | number;
  color?: string;
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 101"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_100_7145)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M79.1819 70.842H64.7384C63.345 70.8418 62.0437 71.5379 61.2703 72.697L59.5779 75.2355C58.8046 76.3946 57.5032 77.0907 56.1098 77.0905H35.5596C34.1662 77.0907 32.8648 76.3946 32.0915 75.2355L30.3991 72.697C29.6241 71.5376 28.3214 70.8417 26.9268 70.842H12.4875C10.1857 70.8429 8.31992 72.7086 8.31909 75.0104V79.1788C8.31909 81.3901 9.19663 83.5109 10.7602 85.0745C12.3238 86.6381 14.4447 87.5163 16.6559 87.5157H75.0135C77.2248 87.5163 79.3456 86.6381 80.9092 85.0745C82.4728 83.5109 83.3503 81.3901 83.3503 79.1788V75.0104C83.3495 72.7086 81.4837 70.8429 79.1819 70.842Z"
          fill="#E2FAED"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M79.1819 70.842H64.7384C63.345 70.8418 62.0437 71.5379 61.2703 72.697L59.5779 75.2355C58.8046 76.3946 57.5032 77.0907 56.1098 77.0905H35.5596C34.1662 77.0907 32.8648 76.3946 32.0915 75.2355L30.3991 72.697C29.6241 71.5376 28.3214 70.8417 26.9268 70.842H12.4875C10.1857 70.8429 8.31992 72.7086 8.31909 75.0104V79.1788C8.31909 81.3901 9.19663 83.5109 10.7602 85.0745C12.3238 86.6381 14.4447 87.5163 16.6559 87.5157H75.0135C77.2248 87.5163 79.3456 86.6381 80.9092 85.0745C82.4728 83.5109 83.3503 81.3901 83.3503 79.1788V75.0104C83.3495 72.7086 81.4837 70.8429 79.1819 70.842Z"
          stroke={color}
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        d="M37.4956 20.8215H19.8966C16.0466 20.5977 12.7372 23.5218 12.4852 27.37V70.8423"
        stroke={color}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M79.0179 70.5357V35.7142"
        stroke={color}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M74.3102 15.8129L79.2586 20.7609L74.2536 25.7688"
        stroke={color}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M54.0556 15.8492L49.1071 20.7972L54.1122 25.8018"
        stroke={color}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M66.7066 12.5L61.6996 29.1487"
        stroke={color}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <filter
          id="filter0_d_100_7145"
          x="1.81909"
          y="69.342"
          width="88.0312"
          height="30.6736"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="6" />
          <feGaussianBlur stdDeviation="2.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_100_7145"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_100_7145"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default Desktop;
